import { Filter } from '@cubejs-client/core';

import { DimPurchaseOrderItemField } from '~/common/types/cubes/DimPurchaseOrderItem';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { PurchaseOrderVolumeShareWidget } from './PurchaseOrderVolumeShareWidget';

export const CommodityGroupPurchaseOrderVolumeShareWidget = () => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimPurchaseOrderItemField.COMMODITY_GROUP_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <PurchaseOrderVolumeShareWidget filters={filters} />;
};
